import { render, staticRenderFns } from "./NormalSearchNav127.vue?vue&type=template&id=707cfdae&scoped=true"
import script from "./NormalSearchNav127.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav127.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707cfdae",
  null
  
)

export default component.exports